"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDelayVisible = void 0;
var react_1 = require("react");
var controlled_1 = require("../form/controlled");
/**
 * @hooks
 *
 * 延迟设置可见值
 */
function useDelayVisible(option) {
    // 让 visible 属性支持 default
    var _a = (0, controlled_1.useDefaultValue)({
        defaultValue: option.defaultVisible,
        value: option.visible,
        onChange: option.onVisibleChange,
    }, false), visible = _a.value, onVisibleChange = _a.onChange;
    var lastTaskCancellation = (0, react_1.useRef)(null);
    // 延时 timeout 再切换到新的状态，任务保存到 taskRef 中
    // 如果有新的变化，清空上次任务，重新开启新任务
    var setVisible = function (nextVisible, delay) {
        if (delay === void 0) { delay = 0; }
        return new Promise(function (resolve) {
            if (lastTaskCancellation.current) {
                lastTaskCancellation.current();
            }
            var timer = setTimeout(function () {
                onVisibleChange(nextVisible);
                resolve(true);
            }, delay);
            var cancel = function () {
                clearTimeout(timer);
                resolve(false);
            };
            lastTaskCancellation.current = cancel;
        });
    };
    // unmout 的时候无论如何都清除任务
    (0, react_1.useEffect)(function () { return function () {
        if (lastTaskCancellation.current) {
            return lastTaskCancellation.current();
        }
    }; }, []);
    return { visible: visible, setVisible: setVisible };
}
exports.useDelayVisible = useDelayVisible;
